import React from "react";
import { Grid, Card } from "@mui/material";
import DashboardLayout from "../DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "ui/MDBox";
import MDTypography from "ui/MDTypography";
import { Link } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

export const DetailPageLayout = ({ title, renderContent, loading, actionButtons, backButtonRoute }) => {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        {loading ? (
          <MDTypography variant="body2">Loading...</MDTypography>
        ) : (
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Card>
                <MDBox mt={2}>
                  <DetailPageHeader 
                    title={title}
                    actionButtons={actionButtons} 
                    backButtonRoute={backButtonRoute}
                  />
                  <Card sx={{ padding: 2, borderRadius: 1, boxShadow: 1 }}>
                    {renderContent()}
                  </Card>
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        )}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

export const DetailPageHeader = ({ 
  title, 
  actionButtons = null, 
  backButtonRoute = null,
  coloredShadow = "info", 
  titleColor = "white" 
}) => {
  return (
    <MDBox
      mx={2}
      mt={-6}
      py={3}
      px={2}
      variant="gradient"
      bgColor={"info"}
      borderRadius="lg"
      coloredShadow={coloredShadow}
      display="flex"
      justifyContent="space-between"
      alignItems="center"
    >
      <MDBox display="flex" alignItems="center">
        {backButtonRoute && (
          <IconButton
            component={Link}
            to={backButtonRoute}
            style={{ color: 'white', marginRight: "8px" }}
          >
            <ArrowBackIcon />
          </IconButton>
        )}
        <MDTypography variant="h6" color={titleColor}>
          {title}
        </MDTypography>
      </MDBox>
      {actionButtons && (
        <MDBox display="flex" alignItems="center">
          {actionButtons()}
        </MDBox>
      )}
    </MDBox>
  );
};
